import { render, staticRenderFns } from "./life.vue?vue&type=template&id=b6266f8c"
import script from "./life.vue?vue&type=script&lang=js"
export * from "./life.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports